export enum GROUP_TYPE {
    REGULAR = 'REGULAR',
    COMPARISON = 'COMPARISON',
    COMPARISON_CATEGORY_BENCHMARK = 'COMPARISON_CATEGORY_BENCHMARK',
}
